function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { size, getSpacing, getDisplay } from '../utils/helpers';
var Spacer = styled.div(_templateObject(), function (_ref) {
  var variant = _ref.variant;

  if (variant === 'line') {
    return {
      height: '1px'
    };
  }

  return _extends({}, size({
    height: 15
  }));
}, function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  var colors = theme.colors;
  return {
    backgroundColor: colors[color]
  };
}, getSpacing, getDisplay);
Spacer.propTypes = {
  variant: PropTypes.oneOf(['line', 'fat']),
  color: PropTypes.oneOf(['black', 'white', 'grey1', 'grey2', 'grey3', 'grey4', 'primary1', 'primary2'])
};
Spacer.defaultProps = {
  variant: 'line',
  color: 'grey1'
};
export default Spacer;